export type AccountsModuleDef = {
  slug: string;
  label: string;
  icon: string;
  title: string;
  description: string;
};

export const ACCOUNTS_MODULES: AccountsModuleDef[] = [
  {
    slug: 'collection',
    label: 'Collection',
    icon: '💰',
    title: 'Collection',
    description: 'Division 10 aged AR overview — drill into a mother for full Collection detail.',
  },
];

export const ACCOUNTS_DEFAULT_SLUG = 'collection';
